import { Inject, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { HttpClientModule } from '@angular/common/http';
import { AuthGuard } from './auth.guard';
import { AuthService } from './services/auth.service';
import { AuthConfig } from 'angular-oauth2-oidc';

@NgModule({
  imports: [
    ReactiveFormsModule,
    OAuthModule.forRoot(),
    HttpClientModule
  ],
  providers: [
    AuthService,
    AuthGuard
  ]
})

export class AuthModule {
  constructor(private oauthService: OAuthService, @Inject('AUTH_CONFIG') private authConfig: AuthConfig) {
    this.configureWithNewConfigApi();
  }

  private configureWithNewConfigApi() {
    this.oauthService.configure(this.authConfig);
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService.tryLogin();
  }
}
